import { Component, OnInit } from '@angular/core';
import { DataStateChangeEvent, GridDataResult, SelectAllCheckboxState, RowArgs, PageChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { BuilderService } from '@app/modules/builder/base';
import { DatePipe } from '@angular/common';
import { SessionService, AccountService, LotStatusEnum, ConstantsService } from '@app/base/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { SocoHttpService } from '@app/base/soco';
import { focusFirstInvalidField, triggerFormValidation } from '@app/shared/functions';
import { RequestLot } from '@app/base/core/models/app/request.lot.model';
import { RequestServiceModel } from '@app/base/core/models/app/request.service.model';
import { RequestServiceModelView } from '@app/base/core/models/app/request.service.model.view';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { Router, ActivatedRoute } from '@angular/router';

declare var swal: any;
require('sweetalert');

interface SubName {
  id: string;
  itemName: string;
}

@Component({
  selector: 'app-request-lot',
  templateUrl: './request-lot.component.html',
  styleUrls: ['./request-lot.component.css']
})
export class RequestLotComponent implements OnInit {


  public SearchResultsGridView: GridDataResult;
  public DuplicateRecordsGrid: GridDataResult;
  companyForm: FormGroup;
  GridId: number;
  defaultSkip = 0;
  defaultSkip2 = 0;
  public projectNumber;
  public insDate: any;
  defaultItemsPerPage = 5;
  defaultItemsPerPage2 = 5;
  data: string;

  allocatedLot = 0;
  noOfLots = 0;
  totalAllocatedLots = 5;

  public skip = 0;
  public skip2 = 0;
  public pageSize = 5;
  public pageSize2 = 5;

  userName: string;
  builderId: string;
  companyName: string;
  subList: SubName[];
  refreshPageFlag = false;
  public selectedLots = 0;
  public allocationButton = true;

  router: Router;

  public pageSizes = true;
  public navFlag;
  public previousNext = true;
  public buttonCount = 5;
  public routeParamFlag;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';

  requestLotsForm: FormGroup;
  public checkedLots: RequestServiceModelView[];
  public newRecordLot: RequestServiceModel[];
  public lotdetails: RequestServiceModelView[] = [];
  requestLots: RequestLot = new RequestLot();
  public routeSubscription: any;
  public CompanyBuilder = new Map();

  public selectAllState: SelectAllCheckboxState = 'unchecked';

  public mySelection: any[] = [];
  public lotOriginal: number[] = [];
  public originalLotList: number[] = [];
  public originalLotGrid: RequestServiceModelView[] = [];
  public duplicateLotGrid: RequestServiceModelView[] = [];
  public idList: number[] = [];
  public lotOriginalCount: string[] = [];
  public builderIdList: string[] = [];
  public companyList: string[] = [];
  public result: ExcelExportData;
  public result2: ExcelExportData;


  public listItems: Array<{ text: string; value: string }> = [
    { text: 'Requested Allocation', value: 'RA' },
    { text: 'Unallocated', value: 'RNL' },
    { text: 'Unallocated', value: 'NLA' },
    { text: 'Unallocated', value: 'NLD' },
    { text: 'Allocated', value: 'AA' },
    { text: 'Allocation Denied', value: 'AD' },
    { text: 'Allocated', value: 'SR' },
    { text: 'Allocated', value: 'SA' },
    { text: 'Allocated', value: 'SD' },
    { text: 'Allocated', value: 'ACR' },
    { text: 'Allocated', value: 'ACA' },
    { text: 'Allocated', value: 'ACD' },
    { text: 'Allocated', value: 'DR' },
    { text: 'Allocated', value: 'DA' },
    { text: 'Allocated', value: 'DD' },
    { text: 'ReAllocated', value: 'REA' }
  ];

  public state: State = {
    skip: this.defaultSkip,
    take: this.defaultItemsPerPage,
    filter: {
      logic: 'and',
      filters: []
    }
  };

  public state2: State = {
    skip: this.defaultSkip2,
    take: this.defaultItemsPerPage2,
    filter: {
      logic: 'and',
      filters: []
    }
  };

  public selectableSettings = {
    checkboxOnly: true,
    mode: 'multiple'
  };
  public options: any = {
    locale: { format: 'MM/DD/YYYY' },
    alwaysShowCalendars: false,
    singleDatePicker: true,
    autoUpdateInput: false,
    showDropdowns: true,
    minYear: 1901,
  };


  public mySelectionKey(context: RowArgs) {
    this.data = context.dataItem.lotStatus;
    return context.dataItem;

  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.SearchResultsGridView = process(this.originalLotGrid, this.state);

  }

  public dataStateChange2(state: DataStateChangeEvent): void {
    this.state2 = state;
    this.DuplicateRecordsGrid = process(this.duplicateLotGrid, this.state2);

  }


  constructor(private fb: FormBuilder, public sessionSvc: SessionService,
    private socoHttp: SocoHttpService, private builderSvc: BuilderService,
    public route: ActivatedRoute,
    private accountSvc: AccountService, _router: Router,
    public constSvc: ConstantsService,
    public datepipe: DatePipe
  ) {
    this.router = _router;
    this.userName = this.accountSvc.account.user.username;
    // getting builder info
    const subscription = this.builderSvc.getBuilderInfo(this.accountSvc.account.user.company).subscribe(
      result => {
        if (subscription) {
          subscription.unsubscribe();
        }
        this.builderId = result.data.id;
        this.companyName = result.data.companyName;
        this.getLots();
      });
    this.allData = this.allData.bind(this);
    this.allData2 = this.allData2.bind(this);
  }

  // getting lots: begin flow
  getLots() {
    this.routeSubscription = this.route.params.subscribe(params => {
      if (params['id']) {
        this.GridId = (params['id']);
      }
      if (params['navFlag']) {
        this.routeParamFlag = (params['navFlag']);
      }
    });

    if (this.refreshPageFlag) {
      this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
    }

    const subscription = this.builderSvc.GetLots(this.GridId, this.builderId).subscribe(result => {
      if (subscription) {
        subscription.unsubscribe();
      }
      this.lotdetails = result.data;
      this.lotdetails.forEach(item => { item.builderCName = this.companyName; });
      this.lotdetails.forEach(item => {
        if (item.installedDTTM !== null) {
          item.installedDTTM = new Date(item.installedDTTM.toString());
        }
      });
      this.lotdetails.forEach(item => {
        if (item.recUpdateDttm !== null) {
          item.recUpdateDttm = this.datepipe.transform(item.recUpdateDttm, 'dd-MMM-yy HH:mm:ss');
        }
      });
      this.getBuilderNames();
    },
      (error) => {
       // swal(this.constSvc.errorSwal1, this.constSvc.getLotsFailsSwal, this.constSvc.errorSwal);
      });
  }

  // getting Builder Names
  getBuilderNames() {
    let ld: any;

    for (ld in this.lotdetails) {

      if (!this.builderIdList.find(x => x === this.lotdetails[ld].builderId)) {
        this.builderIdList.push(this.lotdetails[ld].builderId);
      }

    }
    const subscription = this.builderSvc.getSubsidiaryInfo(this.builderIdList).subscribe(result => {
      if (subscription) {
        subscription.unsubscribe();
      }
      for (const rs in result.data) {
        this.lotOriginalCount.push(result.data[rs].id);
        this.CompanyBuilder.set(this.lotOriginalCount[rs], result.data[rs].companyName);
      }
      this.getOriginalLotBD();
    },
      (error) => {
       // swal(this.constSvc.errorSwal1, this.constSvc.subsidiaryDetailsFailSwal, this.constSvc.errorSwal);
      });
  }


  // allocated to and requested by logic
  getOriginalLotBD() {
    let rs: any;

    for (rs in this.lotdetails) {

      if (!this.lotOriginal.find(x => x === this.lotdetails[rs].lotNumber)) {

        if (!(this.idList.includes(this.lotdetails[rs].id))) {
          this.idList.push(this.lotdetails[rs].id);
        }

        this.lotOriginal.push(this.lotdetails[rs].lotNumber);
        let js: any;

        for (js in this.lotdetails) {

          if (this.lotdetails[js].lotNumber === this.lotdetails[rs].lotNumber && (this.lotdetails[js].lotStatus !== 'RA' &&
            this.lotdetails[js].lotStatus !== 'REA' && this.lotdetails[js].lotStatus !== 'AD')
            && this.lotdetails[js].id !== this.lotdetails[rs].id) {

            this.lotdetails[rs].originalBd = this.lotdetails[js].builderId;
            this.lotdetails[rs].originalCName = this.CompanyBuilder.get(this.lotdetails[js].builderId);
          }
        }

      }
    }
    this.getCheckBoxStatus();
  }

  // checkbox disabling logiC
  getCheckBoxStatus() {
    let rs: any;
    let js: any;
    let p: any;

    for (rs in this.lotdetails) {

      if (this.idList.includes(this.lotdetails[rs].id)) {
        p = this.lotdetails[rs].lotNumber;

        for (js in this.lotdetails) {
          if (this.lotdetails[js].lotNumber === p &&
            this.lotdetails[js].id !== this.lotdetails[rs].id) {

            if (this.lotdetails[js].lotStatus === 'RA' && this.lotdetails[js].builderId === this.builderId) {
              this.lotdetails[rs].checked = false;
              break;
            } else {
              if ((this.lotdetails[js].lotStatus === 'REA' || this.lotdetails[js].lotStatus === 'AD') &&
                this.lotdetails[js].builderId === this.builderId) {
                this.lotdetails[rs].checked = true;
              } else if (this.lotdetails[js].builderId === this.builderId) {
                this.lotdetails[rs].checked = false;
                break;
              }
            }
          }
        }
      }
    }
    this.getStatusDesc();
  }

  // status cd to status
  getStatusDesc() {
    let rs: any;
    for (rs in this.lotdetails) {

      this.lotdetails[rs].statusDesc = this.listItems.find(x => x.value === this.lotdetails[rs].lotStatus).text;

      // counts

      if (this.lotdetails[rs].originalBd === this.builderId) {
        this.allocatedLot += 1;
      }

      if (this.lotdetails[rs].lotStatus === LotStatusEnum.NLA || this.lotdetails[rs].originalCName != null) {
        this.noOfLots += 1;
      }

      if (this.lotdetails[rs].originalBd != null) {
        this.totalAllocatedLots += 1;
      }
    }
    this.removeDuplicate();
  }

  // remove duplicate and already allocated lots
  removeDuplicate() {
    let rs: any;
    let js: any;
    for (rs in this.lotdetails) {

      if (!this.originalLotList.find(x => x === this.lotdetails[rs].lotNumber)) {
        this.originalLotList.push(this.lotdetails[rs].lotNumber);

        if (this.lotdetails[rs].originalBd !== this.builderId) {

          for (js in this.lotdetails) {

            if (this.lotdetails[js].lotNumber === this.lotdetails[rs].lotNumber &&
              this.lotdetails[js].id !== this.lotdetails[rs].id && this.lotdetails[js].statusDesc === this.constSvc.Allocated) {
              this.lotdetails.splice(js, 1);
            }
          }
        }
      }
    }
    if (this.noOfLots === this.allocatedLot) {
      this.allocationButton = false;
    }
    this.divideData();
  }

  // divide data into two grids
  divideData() {
    let rs: any;
    let js: any;
    /* tslint:disable */
    // for (js in this.lotdetails) {
    //  if (this.idList.includes(this.lotdetails[js].id)/* && this.lotdetails[js].checked === false*/) {
    //    this.lotdetails.splice(js, 1);
    //  }
    // }

    for (rs in this.lotdetails) {
      if (this.idList.includes(this.lotdetails[rs].id)) {
        this.originalLotGrid.push(this.lotdetails[rs]);
      }
      // else {
      //  this.duplicateLotGrid.push(this.lotdetails[rs]);
      // }
    }

    for (js in this.originalLotGrid) {
      if (this.originalLotGrid[js].lotStatus === 'SA' || this.originalLotGrid[js].lotStatus === 'ACR' ||
        this.originalLotGrid[js].lotStatus === 'ACA' || this.originalLotGrid[js].lotStatus === 'ACD' ||
        this.originalLotGrid[js].lotStatus === 'DR' || this.originalLotGrid[js].lotStatus === 'DA' ||
        this.originalLotGrid[js].lotStatus === 'DD') {
        this.originalLotGrid[js].checked = false;
      }
    }

    this.loadItems();
  }


  // selection of items in grid
  selectedKeysChange(e) {

    this.selectedLots = e.length;
    this.checkedLots = e;

  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
  }

  public pageChange2(event: PageChangeEvent): void {
    this.skip2 = event.skip;
  }

  // loading grid
  private loadItems(): void {

    this.SearchResultsGridView = {
      data: this.originalLotGrid.slice(this.skip, this.skip + this.pageSize),
      total: this.originalLotGrid.length
    };

    this.DuplicateRecordsGrid = {
      data: this.duplicateLotGrid.slice(this.skip2, this.skip2 + this.pageSize2),
      total: this.duplicateLotGrid.length
    };
    this.socoHttp.hidePleaseWait('ContainerAwaiter');

  }

  // ngOninit
  ngOnInit() {
    this.companyForm = new FormGroup({
      subsidaryCompany: new FormControl(
        null,
        [Validators.required]
        )
      });
      this.sessionSvc.builderData.subscribe(result => {
        if (result) {
          this.socoHttp.hidePleaseWait('ContainerAwaiter1');
          this.builderId = result.BuilderId[0];
          this.subList = [];
          console.log(this.builderId);
          this.subList.push({ id: this.builderId, itemName: result.CompanyName });
          for ( const i of result.BuilderMapping ) {
           if ( i.status === 'Approved' ) {
          this.subList.push({ id: String(i.subsidiaryId), itemName: i.subsidiaryName.toString()});
          console.log(this.subList);
           }
          }
        } else {
          this.builderSvc.getBuilderInfo(this.accountSvc.account.user.company).subscribe(
            result => {
              if (result.data !== undefined && result.data.length !== 0) {
               this.builderId = result.data.id;
               this.subList = [];
               this.subList.push({ id: this.builderId, itemName: this.accountSvc.account.user.company });
               for ( const i of result.data.builderMapping ) {
                if ( i.status === 'Approved' ) {
                this.subList.push({ id: String(i.subsidiaryId), itemName: i.subsidiaryName.toString() });
                console.log(this.subList);
                this.socoHttp.hidePleaseWait('ContainerAwaiter1');
                }
            }
      }
    });
        }
        },
        error => {
          this.socoHttp.hidePleaseWait('ContainerAwaiter1');
        });
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');

    window.scroll(0, 100);
    this.SearchResultsGridView = process(this.originalLotGrid, this.state);
    this.DuplicateRecordsGrid = process(this.duplicateLotGrid, this.state2);


    this.requestLotsForm = this.fb.group(
      {
        'installationDate': ['', Validators.required]
      });
  }


  // code to export grid data to excel
  public allData(): ExcelExportData {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
    this.result = {
      data: process(this.originalLotGrid, { filter: this.state.filter }).data
    };
    this.socoHttp.hidePleaseWait('ContainerAwaiter2');
    return this.result;
  }
  public allData2(): ExcelExportData {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter2');
    this.result2 = {
      data: process(this.duplicateLotGrid, { filter: this.state2.filter }).data
    };
    this.socoHttp.hidePleaseWait('ContainerAwaiter2');
    return this.result2;
  }

  // getting installation date
  get installationDate() {
    return this.requestLotsForm.get('installationDate');
  }

  // export to excel and pdf disable LOT GRID
  checkExportLot(): boolean {
    if (this.originalLotGrid.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  // export to excel and pdf disable REQUEST GRID
  checkExportReq(): boolean {
    if (this.duplicateLotGrid.length === 0) {
      return true;
    } else {
      return false;
    }
  }


  // selection of lots for allocation
  selectedLot() {
    if(this.companyForm.valid) {
    if (this.selectedLots <= 0) {
      // swal(this.constSvc.lotAllocationSwal3, this.constSvc.selectAllocation, this.constSvc.errorSwal);
    } else {
      this.requestLots.installationDate = new Date(this.installationDate.value);
      this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
      this.createLots();
    }
  } else {
    triggerFormValidation(this.companyForm);
    focusFirstInvalidField(this.companyForm);
  }
  }

  // lot creation logic

  createLots() {
    let j: any;
    this.newRecordLot = this.checkedLots;

    for (j in this.newRecordLot) {
      this.newRecordLot[j].id = undefined;
      this.newRecordLot[j].lotStatus = LotStatusEnum.RA;
      this.newRecordLot[j].builderId = this.companyForm.controls['subsidaryCompany'].value['id'];
      this.newRecordLot[j].builderCName = this.companyForm.controls['subsidaryCompany'].value['itemName'];
      this.newRecordLot[j].installedDTTM = this.requestLots.installationDate;
      this.newRecordLot[j].recCreateDttm =  this.datepipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constSvc.TimeZone);
      this.newRecordLot[j].recCreateUsrId = this.accountSvc.account.user.username;
      this.newRecordLot[j].recUpdateDttm =  this.datepipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constSvc.TimeZone);
      this.newRecordLot[j].recUpdateUsrId = this.accountSvc.account.user.username;
      this.newRecordLot[j].lotStatusUpdatedBy = this.accountSvc.account.user.username;
      this.newRecordLot[j].lotStatusUpdatedDate =  this.datepipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constSvc.TimeZone);
    }

    this.builderSvc.PostCreateLots(this.newRecordLot).subscribe(result => {
      if (result) {
        this.socoHttp.hidePleaseWait('ContainerAwaiter');
        swal(this.constSvc.lotAllocationSwal1, this.constSvc.lotAllocationSwal2, this.constSvc.successSwal);
      } else {
        this.socoHttp.hidePleaseWait('ContainerAwaiter');
        swal(this.constSvc.lotAllocationSwal1, this.constSvc.lotAllocationSwal3, this.constSvc.errorSwal);
      }

      this.refreshPage();
    },
      (error) => {
        this.socoHttp.hidePleaseWait('ContainerAwaiter');
       // swal(this.constSvc.lotCreationReqSwal, this.constSvc.lotCreationFailSwal, this.constSvc.errorSwal);
      });
  }

  // new lot page Back button logic
  routeFlag() {
    this.navFlag = 'blr-rl';
    const substr: number = this.router.url.indexOf('builder') + 7;
    const str = this.router.url.slice(0, substr);
    this.router.navigate([str + '/' + 'lot/new/' + this.GridId + '/' + this.builderId + '/' + this.navFlag]);
  }

  // Request lot back button logic
  goToPrevious() {
    const a = this.routeParamFlag;

    if (a === 'l-blr') {
      this.builderSvc.individualServiceClicked = true;
      const substr: number = this.router.url.indexOf('builder') + 7;
      const str = this.router.url.slice(0, substr);
      this.router.navigate([str + '/' + 'request/new/location']);
    } else if (a === 's-blr' || a === 'blr-rl') {
      const substr: number = this.router.url.indexOf('builder') + 7;
      const str = this.router.url.slice(0, substr);
      this.router.navigate([str + '/' + 'request/' + this.GridId +
        '/' + 'service']);
    }
  }

  // refreshing grid post submission of request
  refreshPage() {
    this.refreshPageFlag = true;
    this.mySelection = [];
    this.selectedLots = 0;
    this.newRecordLot = null;
    this.checkedLots = null;
    this.noOfLots = 0;
    this.allocatedLot = 0;
    this.totalAllocatedLots = 0;
    this.lotOriginal = [];
    this.originalLotList = [];
    this.builderIdList = [];
    this.companyList = [];
    this.originalLotGrid = [];
    this.duplicateLotGrid = [];
    this.idList = [];
    this.lotOriginalCount = [];
    this.getLots();
  }
  navigateHome() {
    this.sessionSvc.GetBcaData(null);
    this.router.navigate([
      this.sessionSvc.paramLdc.toLowerCase(),
      'builder',
      'home'
    ]);
  }
}



